export const contactUsConstants = {
    ADD_CONTACTUS_REQUEST: '[ContactUs] Add request',
    ADD_CONTACTUS_FAILURE: '[ContactUs] Add failure',
    ADD_CONTACTUS_DONE: '[ContactUs] Add done',
}
